// Order.js
export const Order = {
  list: async () => [],
  filter: async (query) => []
};
